import { render, staticRenderFns } from "./packing_type.vue?vue&type=template&id=208589a0"
import script from "./packing_type.vue?vue&type=script&lang=js"
export * from "./packing_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports